const STORAGE_KEY = "dadaToken";

export function getDadaToken(): string | null {
  return localStorage.getItem(STORAGE_KEY);
}

export function setDadaToken(token: string): void {
  localStorage.setItem(STORAGE_KEY, token);
}

/** 从 URL 查询参数中读取 token 并持久化为 dadaToken */
export function initDadaTokenFromUrl(): void {
  const token = new URLSearchParams(window.location.search).get("token");
  if (token) {
    setDadaToken(token);
  }
}
